import React from "react";
import { observer } from "mobx-react";
import { store } from "@store";
import { ErrorCard } from "@components";
import { CustomerEventLogStore, CustomerCommentEventMeta } from "./CustomerEventLogStore";
import CommentBox from "../CommentBox/CommentBox";
import CustomerCommentBoxHeader, {
  CustomerCommentBoxHeaderProps
} from "../components/CustomerCommentBoxHeader";
import { EventLogLayout } from "../components/EventLogLayout";
import CustomerEvent from "./CustomerEvent/CustomerEvent";
import { ReminderEvent } from "./CustomerEvent/ReminderEvent";
import { CustomerEventType } from "@bonliva-crm/graphql";

type Props = {
  commentBoxMeta: CustomerCommentEventMeta;
  commentBoxHeaderProps: CustomerCommentBoxHeaderProps;
  store: CustomerEventLogStore;
  onUpload?: () => any;
  uploadDisabled?: boolean;
};

@observer
class CustomerEventLog extends React.Component<Props> {
  componentWillUnmount() {
    this.props.store.unsubscribe();
  }

  renderCustomerCommentBox = () => {
    const { commentBoxHeaderProps, commentBoxMeta, onUpload, uploadDisabled } =
      this.props;

    return (
      <CommentBox
        extraContentBefore={<CustomerCommentBoxHeader {...commentBoxHeaderProps} />}
        onComment={(data) =>
          this.props.store.addCustomerComment(data, commentBoxMeta)
        }
        onMetInPerson={(data) => this.props.store.addMetInPerson(data, commentBoxMeta)}
        teamsDisabled={false}
        onUpload={onUpload}
        smsDisabled={!store().user.canSms}
        uploadDisabled={uploadDisabled}
        userName={store().user.name}
        withButtons={["comment", "metInPerson"]}
        skipReminder
        withUpload
      />
    );
  };

  renderList = () => {
    const { store } = this.props;

    return (
      <div>
        {store.eventsSorted.map((item) => {
          if (item.Type === CustomerEventType.Reminder) {
            return (
              <div key={item._id}>
                <ReminderEvent item={item} />
              </div>
            );
          }
          return (
            <div key={item._id}>
              <CustomerEvent item={item} store={store} />
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    if (this.props.store.error) {
      return <ErrorCard message={this.props.store.error.toString()} title="Error" />;
    }

    return (
      <EventLogLayout
        commentBox={this.renderCustomerCommentBox()}
        loading={this.props.store.loading}
        list={this.renderList()}
        search=""
      />
    );
  }
}

export default CustomerEventLog;
